import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/images/succes-not.png'
import _imports_1 from './assets/images/Shape.png'


const _withScopeId = n => (_pushScopeId("data-v-e23d1276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-col-12" }
const _hoisted_2 = {
  key: 0,
  class: "notification"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#162020"} }, "Success! Your payment has been issued by the client!"),
  /*#__PURE__*/_createElementVNode("span", null, "In the next 24h you’ll receive your reward and this contract will be closed!")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "open-btn" }, "Open dispute", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "notification"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#162020"} }, "This Contract has been archived."),
  /*#__PURE__*/_createElementVNode("span", null, "You’re previewing information in Read Only mode.")
], -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    ($props.status === 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    ($props.status === 'archived')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}